import { useState } from 'react'
import { useAuthStore } from '../store'
import logoSvg from '../../../assets/logo.svg'

// ===========================================
// Página de Login (solicitar magic link)
// ===========================================

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [devLink, setDevLink] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { requestMagicLink, error, clearError } = useAuthStore()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    clearError()
    setIsSubmitting(true)

    try {
      const result = await requestMagicLink(email)
      setSent(true)

      // En desarrollo, mostrar el link
      if (result.devMagicLink) {
        setDevLink(result.devMagicLink)
      }
    } catch {
      // Error ya está en el store
    } finally {
      setIsSubmitting(false)
    }
  }

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="card" style={{ maxWidth: '400px', width: '100%' }}>
          <div className="text-center space-y-3">
            <img src={logoSvg} alt="Rondela" style={{ width: '64px', height: '64px', margin: '0 auto' }} />
            <h1 style={{ fontSize: 'var(--font-size-xl)', fontWeight: 600 }}>
              Revisa tu correo
            </h1>
            <p style={{ color: 'var(--color-gray-600)' }}>
              Si tu correo <strong>{email}</strong> está registrado, recibirás un enlace de acceso.
            </p>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-500)', marginTop: 'var(--spacing-sm)' }}>
              El enlace expira en 15 minutos
            </p>

            {/* Link de desarrollo */}
            {devLink && (
              <div
                style={{
                  marginTop: 'var(--spacing-lg)',
                  padding: 'var(--spacing-md)',
                  backgroundColor: 'var(--color-gray-100)',
                  borderRadius: 'var(--radius-md)',
                  fontSize: 'var(--font-size-sm)',
                }}
              >
                <p style={{ fontWeight: 500, marginBottom: 'var(--spacing-xs)' }}>
                  🔧 Modo desarrollo:
                </p>
                <a
                  href={devLink}
                  style={{
                    wordBreak: 'break-all',
                    color: 'var(--color-primary)',
                  }}
                >
                  Clic aquí para verificar
                </a>
              </div>
            )}

            <button
              type="button"
              onClick={() => {
                setSent(false)
                setDevLink(null)
                setEmail('')
              }}
              className="btn btn-secondary btn-full mt-4"
            >
              Usar otro correo
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="auth-logo">
          <img src={logoSvg} alt="Rondela" className="auth-logo__image" />
          <h1 className="auth-logo__title">Rondela</h1>
          <p className="auth-logo__subtitle">Guardianes de la Huella</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label htmlFor="email" className="label">
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`input ${error ? 'input-error' : ''}`}
              placeholder="tu@email.com"
              required
              autoComplete="email"
              autoFocus
            />
            {error && <p className="error-message">{error}</p>}
          </div>

          <button
            type="submit"
            disabled={isSubmitting || !email}
            className="btn btn-primary btn-full"
          >
            {isSubmitting ? (
              <span className="flex items-center justify-center gap-2">
                <span className="spinner" />
                Enviando...
              </span>
            ) : (
              'Enviar enlace de acceso'
            )}
          </button>
        </form>

        <p
          style={{
            marginTop: 'var(--spacing-lg)',
            fontSize: 'var(--font-size-sm)',
            color: 'var(--color-gray-500)',
            textAlign: 'center',
          }}
        >
          Te enviaremos un enlace seguro para acceder sin contraseña.
        </p>
      </div>
    </div>
  )
}
